import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";

import edit from "../../edit.png";
import trash from "../../trash.png";

import PlTitle from "../../elements/PlTitle";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputInteger from "../../helpers/InputInteger";
import InputLegend from "../../helpers/InputLegend";

import SubkontoNew from "./SubkontoNew";
import SubkontoEdit from "./SubkontoEdit";

import FormatAccount from "../../helpers/FormatAccount";
import StawkaNew from "./StawkaNew";
import StawkaEdit from "./StawkaEdit";


import ZajeciaNew from "./ZajeciaNew";
import ZajeciaEdit from "./ZajeciaEdit";
import StReview from "./StReview";
import ContractTemplateEdit from "./ContractTemplateEdit";
import InputTextArea from "../../helpers/InputTextArea";
import InputPassword from "../../helpers/InputPassword";
 


function Start(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);

    const [subkonta, setSubkonta] = useState(null);

    const [stawki, setStawki]     = useState(null);
    const [nazwaStawki, setNazwaStawki] = useState('');
    const [archiwumStawki, setArchiwumStawki] = useState(0);

    const [zajecia, setZajecia] = useState(null);

    const [szablony, setSzablony] = useState(null);


    const [checked, setChecked]   = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };





      const valChangeListenerStawki = (filedName, val, correct, msg) => {

        if(filedName == 'archiwum') setArchiwumStawki(val);
        if(filedName == 'nazwa')   setNazwaStawki(val);
               
       
     }      
    
     const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'stawka przeniesiona do archiwum'
        },
    ]);



 
    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const valChange = (filedName, val, correct, msg) => {

        //  console.log("valChange: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
        setTab( {...tab, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }

    const goNext = () => {
        console.log("goNext");
    }



    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,place', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setTab(res);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const genNumRach = () => {
       

        if(  (tab.numer_rach_uq_bank+"").length != 8)
        {
            props.mainView.showDialog( "Error", "Podaj nr banku, 8 znaków ("+tab.numer_rach_uq_bank +")" , "ok" , null);  
            return;
        }

         if( (tab.numer_rach_uq_klient+"").length != 4)
        {
            props.mainView.showDialog( "Error", "Podaj kod klienta, 4 znaki  ("+tab.numer_rach_uq_klient.length +")" , "ok" , null);  
            return;
        }


        const showMsg = () => {

                  props.mainView.showDialog("Potwierdź", "Na pewno ustawić indywidualne nr rach. dla dzieci, które go jeszze nie mają?", "yesno", (option)=>{
                                    
                                    ///--------
                                    if(option == "yes")
                                    {
                                                props.mainView.setProgress(-2);
                            
                                                var req = {
                                                
                                                }
                            
                                                fetch( Config.master + '/rest_v1,gen_rach', {
                                                    method: 'POST', 
                                                    body: JSON.stringify(req), 
                                                    headers: {
                                                        'Content-Type': 'application/json',                    
                                                        'X-Api-Key': props.userData.apiKey,
                                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                                        '_sec_key_': Config.genXKey() ,
                                                    }
                                                })
                                                .then(res => res.json() )
                                                .then(res => { 
                            
                                                            props.mainView.setProgress(-1);        
                                                            if(res._sys_ == undefined)
                                                            {
                                                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                                            }else
                                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                            {
                                                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                                            }else    
                                                            {      
                                                                props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem." , "ok" , null);                                                                               
                                                            }
                                                } )
                                                .catch(err => {          
                                                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                                            props.mainView.setProgress(-1);
                                                });
                                    }//koniec yes
                                    //--------
                                } );

                                
        }


              //------------------
              //zapisz dane..
              
                        fetch( Config.url + '/rest_v1,place_update', {
                            method: 'POST', 
                            body: JSON.stringify(tab), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => {             
                                    //  
                                    showMsg();

                        } )
                        .catch(err => {
                                    props.mainView.setProgress(-1);
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        });
               

              //----------------------------------------------


       


    }

    const saveData = () => {

        props.mainView.setProgress(-2);
 
        if(!valChecker(tab))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
 
        

        fetch( Config.url + '/rest_v1,place_update', {
            method: 'POST', 
            body: JSON.stringify(tab), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    //  
                    props.mainView.setProgress(-1);

                    if(res.status != null && res.status == 'OK')
                    {
                        props.mainView.showDialog( props.userData.dic.dlg_notice , props.userData.dic.dlg_sukcess , "ok" , null);
                    }else
                    {
                        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_wrong  ,  "ok"  ,null); 
                    }

         } )
         .catch(err => {
                    props.mainView.setProgress(-1);
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }




    const getSubkonta = () => {
       
 
        props.mainView.setProgress(-2);

        
        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,subkonta', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setSubkonta(res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getZajecia = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,zajecia_dodatkowe', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setZajecia(res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const getStawki = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,stawki', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setStawki(res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const getSzablony = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,szablony', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setSzablony (res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    
    const addSzablon = () => {


  
 
        props.mainView.setProgress(-2);

        var req =  {
            id: -1,
            nazwa: "Nowy szablon",
            txt: "Podaj treść...",
        };


        fetch( Config.url + '/rest_v1_calc,szablony_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                   
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        getSzablony();
                        props.mainView.showDialog( "Sukces!", "Dodano 'Nowy szablon'. Możesz go teraz edytować." , "ok" , null);  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }


    const goDeleteOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_calc,subkonta_remove', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getSubkonta();
                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteOK(id);
                        //--------
        } );
    }






    
    const goDeleteTOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_calc,szablony_remove', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getSzablony();
                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDeleteT = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybrany szablon?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteTOK(id);
                        //--------
        } );
    }






    const stawkaSukcess = (p_typy_oplat_id) => {
        getStawki();
    }




    const saveKsef = () => {


        props.mainView.setProgress(-2);

        var req = {
            pem_crt: tab.pem_crt,
            pem_key: tab.pem_key,
            pem_key_pass: tab.pem_key_pass,
        };


        fetch( Config.url + '/rest_v1,ksef_set', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       //console.log("Odp", res);

                       if(res.status == 'ERROR')
                       {
                          props.mainView.showDialog( "Error", res.param , "ok" , null); 
                          alert(res.param);
                       }else 
                       {
                           props.mainView.showDialog( "Sukces", res.param , "ok" , null); 
                           alert(res.param);
                       }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }


    const runSelectFile = (idName) => {

        var h = document.getElementById(idName);
        h.click();        
    }

    const handleFileChangeCRT = (e) => 
    {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (event) => {
             //setContent(event.target.result);

             setTab({...tab, ['pem_crt']:event.target.result });
        };
        reader.readAsText(file); // można też readAsArrayBuffer / readAsDataURL
    };

     const handleFileChangeKEY = (e) => 
    {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (event) => {
             //setContent(event.target.result);

             setTab({...tab, ['pem_key']:event.target.result });
        };
        reader.readAsText(file); // można też readAsArrayBuffer / readAsDataURL
    };



        
        if(tab == null)
        {
            setTab([]);         
            getData();         
            return (
                <div></div>
            );        
        }


        if(subkonta == null)
            {
                setSubkonta([]);         
                getSubkonta();
                return (
                    <div></div>
                );        
        }
    
        if(stawki == null)
            {
                setStawki([]);         
                getStawki();
                return (
                    <div></div>
                );        
        }

        if(zajecia == null)
        {
            setZajecia([]);
            getZajecia();
        }

        if(szablony == null)
        {
            setSzablony([]);
            getSzablony();
        }


        if(tab._sys_ == undefined) //no correct response..
        {
            return (
                <div></div>
            );   
        }
    
    
        if(refreshView != props.userData.refreshView)
        {
            setRefreshView( props.userData.refreshView);
            getData();
            getSubkonta();
            getStawki();
            getZajecia();
        }
    

    var typDokumentu = [
        {
            v: 'f',
            title: 'Faktura'
        },
        {
            v: 'r',
            title: 'Zwykłe rozliczenie'
        }
    ];   


    var terminyPlatnosci = [
        {
            v: '0',
            title: 'Podana ilość dni od daty wystawienia'
        },
        {
            v: '1',
            title: 'Podany dzień miesiąca'
        }
    ]; 
    
    

    var archiwumTakNie = [
        {
            v: '_x_',
            title: '- - -'
        },
        {
            v: '0',
            title: 'Nie'
        },
        {
            v: '1',
            title: 'Tak'
        },
    ]; 

    

    var vatPodstawa = [
        {
            v: 'netto',
            title: 'Netto'
        },
        {
            v: 'brutto',
            title: 'Brutto'
        }
    ]; 


    var scal = [
        {
            v: '0',
            title: 'Wystawiaj rozliczenia i korekty w osobnych dokumentach'
        },
        {
            v: '1',
            title: 'Scal pozycje z rozliczenia i korekty'
        }
    ]; 


    var zerowe = [
        {
            v: '0',
            title: 'Nie wyświetlaj pozycji, których cena lub ilość to 0,00'
        },
        {
            v: '1',
            title: 'Pokaż pozycje, gdy cena lub ilość wynosi 0,00'
        }
    ]; 


    var inxSt = -1;


    return (
        <div className="view_content">

            <div>
                       <a href="#subkonta" className="link_color2">Numery kont do wpłat</a>                      
                       <a href="#stawki" className="link_color2">Stawki obowiązujące w placówce</a>
                       <a href="#zajecia_dodatowe" className="link_color2">Zajęcia dodatkowe</a>
                       <a href="#szablony" className="link_color2">Szablony umów (pdf)</a>
            </div>
            <br/>



           

            <br/>

            <form className="eForm bg_center">



                    <div className="form_tab_title">Dane widoczne na wystawianych rozliczeniach / fakturach </div>
                    <div className="form_tab">
                        
                             <div className="form_control">
                                <div className="fieldName">Nazwa sprzedawcy*</div>
                                <InputText   userData={props.userData} value={tab.fak_sp_nazwa} valChange={valChange} goNext={goNext} name="fak_sp_nazwa" placeholder={ "Nazwa sprzedawcy: "} className=' w300 ' req='1' />
                             </div>


                             <div className="form_control">
                                <div className="fieldName">NIP*</div>
                                <InputNIP   userData={props.userData}  value={tab.fak_sp_nip} valChange={valChange} goNext={goNext} name="fak_sp_nip" placeholder={ "NIP: "} className=' w150' req='1'   />
                            </div>


                             <div className="form_split"></div>

                            <div className="form_control">
                                <div className="fieldName">Ulica*</div>
                                <InputTextAlpha   userData={props.userData}   value={tab.fak_sp_ulica} valChange={valChange} goNext={goNext} name="fak_sp_ulica" placeholder={"Ulica: "} className=' w250' req='1' />
                            </div>

                            <div className="form_control">
                                <div className="fieldName">Nr domu*</div>
                                <InputText  userData={props.userData}  value={tab.fak_sp_nr_domu} valChange={valChange} goNext={goNext} name="fak_sp_nr_domu" placeholder={"Nr domu: "} className=' w50' req='1' />
                            </div>


                            <div className="form_control">
                                <div className="fieldName">Nr mieszkania</div>
                                <InputText    userData={props.userData}  value={tab.fak_sp_nr_mieszkania} valChange={valChange} goNext={goNext} name="fak_sp_nr_mieszkania" placeholder={ "Nr mieszkania: "} className=' w50' req='0' />
                            </div>


                           

                            <div className="form_control">
                                <div className="fieldName">Kod pocztowy*</div>
                                <InputPostCode   userData={props.userData}  value={tab.fak_sp_kod_pocztowy} valChange={valChange} goNext={goNext} name="fak_sp_kod_pocztowy" placeholder={ "Kod pocztowy: "} className=' w50' req='1' />
                            </div>


                            <div className="form_control">
                                <div className="fieldName">Miasto*</div>
                                <InputTextAlpha   userData={props.userData}  value={tab.fak_sp_miasto} valChange={valChange} goNext={goNext} name="fak_sp_miasto" placeholder={ "Miasto: "} className=' w150' req='1' firstUp="1" />
                            </div>


                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>{props.userData.dic.save}</div>
                            </div>                            

                    </div>


                    <br/><br/>

                    


                    
                    <div className="form_tab_title">Ustawienia KSeF</div>
                    <div className="form_tab">

                            <div className="form_control">
                                <div className="fieldName">Certyfikat  
                                    <span className="link_color2" onClick={ ()=>{ runSelectFile('f_pem_crt'); } }>wybierz plik .crt</span> 
                                    <input type="file" id="f_pem_crt" style={{display:'none'}} onChange={handleFileChangeCRT}  accept=".crt" />
                                </div>
                                <InputTextArea    userData={props.userData}  value={tab.pem_crt} valChange={null} goNext={goNext} name="pem_crt" placeholder={ "Certyfikat: "} className=' w250' req='0' />
                            </div>

                              <div className="form_control">
                                <div className="fieldName">Klucz prywatny  
                                    <span className="link_color2" onClick={ ()=>{ runSelectFile('f_pem_key'); } } >wybierz plik .key</span>
                                    <input type="file" id="f_pem_key" style={{display:'none'}} onChange={handleFileChangeKEY}  accept=".key" />
                                </div>
                                <InputTextArea    userData={props.userData}  value={tab.pem_key} valChange={null} goNext={goNext} name="pem_key" placeholder={ "Klucz prywatny: "} className=' w250' req='0' />
                            </div>

                            {
                                tab.pem_key.length > 20 &&
                                <Fragment>
                                    <div className="form_split"></div>
                                    <div className="form_control">
                                        <div className="fieldName">Hasło klucza prywatnego</div>
                                        <InputPassword    userData={props.userData}  value={tab.pem_key_pass} valChange={valChange} goNext={goNext} name="pem_key_pass" placeholder={ "Hasło: "} className=' w200' req='0' />                                                              
                                    </div>
                                </Fragment>
                            }

                            {
                                  tab.pem_key.length > 20 && tab.pem_key_pass.length > 4 &&
                                  <Fragment>
                                        <div className="form_split"></div>
                                        <div className="form_btn">                                 
                                                <div className="btn" onClick={saveKsef}>Zapisz ustawienia KSeF</div>
                                        </div> 
                                  </Fragment>
                            }

                              

                              
                    </div>



                    <br/><br/>
                


                    <div className="form_tab_title">Dodatkowe ustawienia rozliczeń / faktur</div>
                    <div className="form_tab">

                            <div className="form_control">
                                <div className="fieldName">Konta indywidualne*</div>
                                <InputCombo  items={ [ {v:'0', title:'Nie, brak umowy z bankiem'}, {v:'1', title:'Tak, mam umowę z bankiem. Każde dziecko ma swój nr rach. do wpłat'},   ] }  value={tab.numer_rach_auto_uq} valChange={valChange} goNext={goNext} name="numer_rach_auto_uq" placeholder={ ": "} className='  ' req='1' />
                            </div>

                            {
                                tab.numer_rach_auto_uq == '1' &&
                                <Fragment>

                                     <div className="form_control">
                                            <div className="fieldName">Nr banku (8 cyfr)</div>
                                            <InputInteger userData={props.userData} min="10000000" max="99999999" value={tab.numer_rach_uq_bank} valChange={valChange} goNext={goNext} name="numer_rach_uq_bank" placeholder={ ": "} className=' w100' req='1' />
                                     </div>

                                      <div className="form_control">
                                            <div className="fieldName">Kod klienta (4 cyfry)</div>
                                            <InputInteger userData={props.userData} min="1000" max="9999" value={tab.numer_rach_uq_klient} valChange={valChange} goNext={goNext} name="numer_rach_uq_klient" placeholder={ ": "} className=' w100' req='1' />
                                     </div>      

                                    <div className="form_control">Numery konto zostaną przypisane podczas dodawania nowego dziecka. </div>     
                                    <div className="link_color" onClick={genNumRach}> Znajdź dzieci bez numeru rach. i przypisz TERAZ </div>                          

                                </Fragment>
                            }

                            <div className="form_split"></div>
                            <br/>
                            <div className="form_split"></div>
                        
                                    <div className="form_control">
                                            <div className="fieldName">Płatności OnLine, e-mail dla powiadomień</div>
                                            <InputText userData={props.userData} value={tab.bluemedia_powiadomienia} valChange={valChange} goNext={goNext} name="bluemedia_powiadomienia" placeholder={ ": "} className=' w300' req='0' />
                                     </div>  
                        
                            <div className="form_split"></div>

                            <div className="form_btn">                                  
                                    <div className="btn" onClick={saveData}>{props.userData.dic.save}</div>
                            </div> 

                    </div>
                    <br/><br/>


                   

                    <div className="form_tab_title">Ustawienia dokumentów</div>
                    <div className="form_tab">
                 

                             <div className="form_control">
                                <div className="fieldName">Domyślny typ dokumentów*</div>
                                <InputCombo  items={typDokumentu}  value={tab.typ_dokumentu} valChange={valChange} goNext={goNext} name="typ_dokumentu" placeholder={ "Typ: "} className='  ' req='1' />
                            </div>
                            
                            <div className="form_control">
                                <div className="fieldName">Domyślny termin płatności*</div>
                                <InputCombo  items={terminyPlatnosci}  value={tab.termin_pl_opcja} valChange={valChange} goNext={goNext} name="termin_pl_opcja" placeholder={ ": "} className='  ' req='1' />
                            </div>

                            {
                                tab.termin_pl_opcja == 0 &&
                                <div className="form_control">
                                    <div className="fieldName">Ilość dni od daty wystawienia (1-30)</div>
                                    <InputInteger userData={props.userData} min="1" max="30" value={tab.termin_pl_dni} valChange={valChange} goNext={goNext} name="termin_pl_dni" placeholder={ ": "} className=' w50' req='1' />
                                </div>
                            }
                            

                            {
                                  tab.termin_pl_opcja == 1 && 
                                  <div className="form_control">
                                    <div className="fieldName">Dzień miesiąca (3-28) </div>
                                    <InputInteger userData={props.userData}  min="3" max="28" value={tab.termin_pl_dzien} valChange={valChange} goNext={goNext} name="termin_pl_dzien" placeholder={ ": "} className=' w50' req='1' />
                                </div>  
                            }

                          
                        
                            {
                                tab.typ_dokumentu == 'f' &&
                                <Fragment>
                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Podstawa dla VAT*</div>
                                                <InputCombo  items={vatPodstawa}  value={tab.faktura_vat_postawa} valChange={valChange} goNext={goNext} name="faktura_vat_postawa" placeholder={ ": "} className='  ' req='1' />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Informacja na fakturze (np. zwolnienie z VAT na podstawie....)</div>
                                                <InputText    userData={props.userData}  value={tab.faktura_vat_info} valChange={valChange} goNext={goNext} name="faktura_vat_info" placeholder={ "Info: "} className=' w300' req='0' />
                                            </div>


                                         

                                </Fragment>
                            }


                            {
                                tab.typ_dokumentu == 'r' &&
                                <Fragment>
                                            <div className="form_split"></div>
 

                                            <div className="form_control">
                                                <div className="fieldName">Informacja na rozliczeniu (np. zwolnienie z VAT na podstawie....)</div>
                                                <InputText    userData={props.userData}  value={tab.rozliczenie_info} valChange={valChange} goNext={goNext} name="rozliczenie_info" placeholder={ "Info: "} className=' w300' req='0' />
                                            </div>


                                            <div className="form_split"></div>
                                         
                                            <div className="form_control">
                                                <div className="fieldName">**Połącz rozliczenie i korektę rozliczenia*</div>
                                                <InputCombo  items={scal}  value={tab.scal_korekte_fakture} valChange={valChange} goNext={goNext} name="scal_korekte_fakture" placeholder={ ": "} className='  ' req='1' />
                                                <div>
                                                    **W przypadku zastosowania stawek płatnych z góry i wyrównania za okres miniony system może wygenerować pozycje do zwrotu w osobnych dokumentach (korektach) lub umieścić ujemne ilości na rozliczeniu bieżącym.  Nie jest możliwe wystawienie faktur z ilościami ujemnymi. 
                                                </div>  
                                            </div>



                                         <div className="form_split"></div>
                                         <br/>
                                         <div className="form_split"></div>
                                         
                                         <div className="form_control">
                                             <div className="fieldName">Pokaż pozycje na rozliczeniu</div>
                                             <InputCombo  items={zerowe}  value={tab.pozycje_zerowa} valChange={valChange} goNext={goNext} name="pozycje_zerowa" placeholder={ ": "} className='  ' req='1' />                                            
                                         </div>


                                             

                                </Fragment>
                            }

                           <div className="form_split"></div>
                            <div className="form_control">
                                       <div className="fieldName">Podpis na dokumencie</div>
                                       <InputText    userData={props.userData}  value={tab.faktura_podpis} valChange={valChange} goNext={goNext} name="faktura_podpis" placeholder={ "Imię i nazwisko: "} className=' w300' req='0' />
                            </div>


                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>{props.userData.dic.save}</div>
                            </div>  
                                                      

                    </div>

               </form>

                    <a href="#" name="subkonta"></a>
                   <br/><br/>                   
                   <div className="form_tab_title">Rachunki bankowe / Subkonta / Konta bankowe, na które rodzice będą mogli dokonywać wpłaty</div>

                   <div className="bg_center">


                                    <div className="tip">Uwaga 1: Wszystkie zmiany numerów kont należy wykonać przed wystawieniem rozliczeń. </div>
                                    <br/> 
                                    <div className="tip">Uwaga 2: Nowe konto to nowa historia salda rodzica, czasami lepiej zmienić tylko numer rachunku zachowując tym samym historię salda.  </div>
                                    <br/> 
                                    <div className="tip">Uwaga 3: Po dokonaniu zmian zweryfikuj numery kont zawarte w szczegółach umów (przypisanych stawek)  .  </div>

                                    <div className="table_widget">
                                           <SubkontoNew mainView={props.mainView} userData={props.userData} onClose={getSubkonta} /> 
                                    </div>

                                    

                     
                                    <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Numer konta</td>  
                                                <td>Nazwa banku</td>                                                                                     
                                                <td className="td_right">Płatności OnLine</td>   
                                                <td className="td_option"> </td>
                                                <td className="td_option"> </td>                                              
                                            </tr>
                                        </thead>

                                        <tbody>
                                                {
                                                    subkonta.map(  (row, ix) => {


                                                        var blue = "Aktywne";
                                                        if(row.bluemedia != '1') blue = "Nieaktywne";

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                        return <tr className={rowStyle}>
                                                            <td className="gocenter">{ ix + 1 }</td>
                                                            <td>  <FormatAccount value={row.numer_konta} />  </td>  
                                                            <td>{row.nazwa}</td>                                                                                     
                                                            <td className="gocenter">{blue}</td>   
                                                            <td className="td_btn_option">  <SubkontoEdit userData={props.userData} mainView={props.mainView} row={row}  onClose={getSubkonta} /> </td>
                                                            <td className="gocenter td_btn_option"> <img className="ibtn" src={trash} title="usuń"  onClick={goDelete} v="delete" id={row.id} />  </td> 
                                                        </tr>
                                                    } )
                                                }
                                        </tbody>
                                    </table>

                   </div>


                   <a href="#" name="stawki"></a>
                   <br/><br/>                                      
                   <div className="form_tab_title">Stawki i opłaty obowiązujące w placówce</div>       


                  

                   <div className="table_filter">
                      

                            <div className="filter_controll">   
                                <label>Nazwa: </label>                             
                                <InputText   valChange={valChangeListenerStawki}  value={nazwaStawki} name="nazwa" placeholder={"Nazwa: "}   />
                            </div> 

                           <div className="filter_controll">   
                                <label>Przeniesiona do archiwum: </label>                             
                                <InputCombo items={archiwumTakNie}    value={archiwumStawki}   valChange={valChangeListenerStawki}  name="archiwum"  />
                            </div> 

                       
                   </div>   

                   

                    <div className="table_widget">                                      
                              <StawkaNew  userData={props.userData} mainView={props.mainView} onAdded={stawkaSukcess} />
                              <br/>
                              <InputLegend items={legend}/>
                    </div>         


                   <div className="bg_center">                    

                           

                            <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Nazwa stawki / nazwa pozycji na rozliczeniu</td>  
                                                <td>Naliczanie</td>                                                                                     
                                                <td>Kwota</td>   
                                                <td className="td_right">Aktywne umowy</td>
                                                <td className="td_option"> </td>
                                                                                   
                                            </tr>
                                        </thead>
                                        <tbody>
                                                {
                                                
                                                    stawki.map( (row, ix) => {

                                                      

                                                        var filterOk = true;
                                                        var filterOk2 = true;

                                                        if(nazwaStawki.length > 2)                                                        
                                                        {
                                                            filterOk = false;

                                                            if(  row.nazwa.toLowerCase().includes( nazwaStawki.toLowerCase() ) )  filterOk = true;
                                                        }

                                                        if(archiwumStawki != '_x_')
                                                        {
                                                            filterOk2 = false;
                                                            if( row.archiwum == archiwumStawki)  filterOk2 = true;
                                                        }


                                                        if( !filterOk || !filterOk2 ) return null;

                                                        inxSt += 1;

                                                        var spNaliczania = '';
                                                        var cssRow = '';

                                                        if(row.archiwum == '1') cssRow = " color_deleted ";

                                                        if(row.naliczanie_dzienne == '1')     spNaliczania = 'Dzienne';
                                                        if(row.naliczanie_miesieczne == '1')  spNaliczania = 'Miesięczne';
                                                        if(row.naliczanie_godzinowe == '1')   spNaliczania = 'Godzinowe';
                                                        if(row.naliczanie_nadgodzin == '1')   spNaliczania = 'Nadgodziny';
                                                        if(row.naliczanie_jednorazowe == '1') spNaliczania = 'Jednorazowe';
                                                        if(row.naliczanie_wlasne == '1')      spNaliczania = 'Własna definicja';

                                                        if(row.naliczaj_z_gory == '1')
                                                        {
                                                            spNaliczania = spNaliczania +  " / z góry";
                                                        }else 
                                                        {
                                                            spNaliczania = spNaliczania +  " / za okres miniony";
                                                        }
                                                        

                                                        var rowStyle2 = " row ";
                                                        if(inxSt % 2 == 0 )rowStyle2 = " row2 ";

                                                        return <tr className={ rowStyle2 +  " " + cssRow}>
                                                                    <td className="gocenter">{inxSt+1}</td>
                                                                    <td>{row.nazwa}</td>  
                                                                    <td className="goleft">{spNaliczania}</td>                                                                                     
                                                                    <td className="goright">{row.kwota_netto}</td>   
                                                                    <td className="gocenter">
                                                                        <StReview tab={row.umowy} />                                                                     
                                                                    </td>
                                                                    <td className="td_btn_option"> <StawkaEdit  userData={props.userData} mainView={props.mainView} row={row}  onUpdated={stawkaSukcess} /> </td>                                                                  
                                                        </tr>
                                                    } ) 
                                                }
                                        </tbody>
                            </table>
                   </div>

         


                   <a href="#" name="zajecia_dodatowe"></a>
                   <br/><br/>                                      
                   <div className="form_tab_title">Zajęcia dodatkowe</div>    




                   <div className="table_widget">                                      
                              <ZajeciaNew  userData={props.userData} mainView={props.mainView} onAdded={getZajecia}  />
                              <br/>
                              <InputLegend items={legend}/>
                   </div>  



                   <div className="bg_center">                                               
                            <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Nazwa</td>  
                                                <td>Okres zajęć</td>                                                                                     
                                                <td>Terminy / Plan</td>   
                                                <td>Kwota</td>
                                                <td className="">JM.</td>
                                                <td className="td_right">Aktywne umowy</td>
                                                <td className="td_option"></td>
                                                                                   
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                zajecia.map( (item, ix) => {

                                                    var cssRow = '';

                                                    if(item.archiwalne == '1') cssRow = " color_deleted ";

                                                    var tz = '';
                                                    if(item.typ_rozliczania == '1') tz = 'Za lekcję';
                                                    if(item.typ_rozliczania == '2') tz = 'Za miesiąc';


                                                    var rowStyle2 = " row ";
                                                    if(ix % 2 == 0 )rowStyle2 = " row2 ";

                                                    return <tr className={  rowStyle2 +  " " + cssRow } >
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td>{item.nazwa}</td>  
                                                            <td className="gocenter">{item.okres_od} / {item.okres_do}</td>                                                                                     
                                                            <td className="gocenter">
                                                                {
                                                                    item.terminy.map( (tt, ti) => {

                                                                        var dzien = "";

                                                                        if(tt.dzien_tygodnia == 0) dzien = ' Niedziela';
                                                                        if(tt.dzien_tygodnia == 1) dzien = ' Poniedziałek';
                                                                        if(tt.dzien_tygodnia == 2) dzien = ' Wtorek';
                                                                        if(tt.dzien_tygodnia == 3) dzien = ' Środa';
                                                                        if(tt.dzien_tygodnia == 4) dzien = ' Czwartek';
                                                                        if(tt.dzien_tygodnia == 5) dzien = ' Piątek';
                                                                        if(tt.dzien_tygodnia == 6) dzien = ' Sobota';

                                                                        return <span>
                                                                            {dzien} ({tt.godzina}), 
                                                                        </span>
                                                                    } )
                                                                }
                                                            </td>   
                                                            <td className="goright">{item.kwota}</td>
                                                            <td className="gocenter" >{tz}</td>
                                                            <td className="gocenter">
                                                                        <StReview tab={item.umowy} />                                                                     
                                                                    </td>
                                                            <td className="td_btn_option">
                                                                <ZajeciaEdit userData={props.userData} mainView={props.mainView} row={item} onUpdated={getZajecia}  />
                                                            </td>
                                                    </tr>

                                                } )
                                            }
                                        </tbody>
                            </table>
                    </div>





                  <a href="#" name="szablony"></a>
                  <br/><br/>                                      
                  <div className="form_tab_title">Szablon umów</div>   

                  <div>
                    <span className="btn" onClick={addSzablon}>dodaj szablon</span>
                    </div> 

                  {
                        szablony != null &&
                        <Fragment>


                            <div className="bg_center">                                               
                                    <table className="table" >
                                                <thead>
                                                    <tr className="header">
                                                        <td className="td_left">LP</td>
                                                        <td>Nazwa</td>                                                                                                                                                                                         
                                                        <td className="td_right">Treść</td>
                                                        <td className="td_option"></td>
                                                        <td className="td_option"></td>
                                                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        szablony.map( (item, ix) => {

                                                            var cssRow = '';
                                                            var tt = item.tresc;

                                                            if(tt.length > 80)
                                                            {
                                                                tt = tt.substring(0,80) + "...";
                                                            }

                                                          

                                                            var rowStyle2 = " row ";
                                                            if(ix % 2 == 0 )rowStyle2 = " row2 ";

                                                            var newref = JSON.parse( JSON.stringify(item) );

                                                            return <tr className={  rowStyle2 +  " " + cssRow } >
                                                                    <td className="gocenter">{ix+1}</td>
                                                                    <td>{item.nazwa}</td>                                                                             
                                                                    <td className="goleft">{tt}</td>                                                    
                                                                    <td className="td_btn_option">
                                                                       <ContractTemplateEdit userData={props.userData} mainView={props.mainView} row={item} onUpdated={getSzablony}  />                                                                       
                                                                    </td>
                                                                    <td className="gocenter td_btn_option"> <img className="ibtn" src={trash} title="usuń"  onClick={goDeleteT} v="delete" id={item.id} />  </td> 
                                                            </tr>

                                                        } )
                                                    }
                                                </tbody>
                                    </table>
                            </div>

                        </Fragment>

                  }                      


        </div>
    );

}

export default Start;
